<script>
	// Stores 
	import { textSite, mailCondominios, textWhatsappCondominio, linkWhatsappCondominio } from '../store.js';    

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from "../components/PageHeader.svelte";
	import Forms from "../components/Forms.svelte";

	// Code
	let titlePage = 'Proposta de Administração de Condomínio';

	let fields = [
		{
			title:      'Seu nome *',
			name:       'nome',
			required:   'required',
		},
		{
			title:      'Telefone *',
			name:       'telefone',
			required:   'required',
			classe:     'mask-telefone',
		},
		{
			title:      'Email *',
			name:       'email',
			type:       'email',
			required:   'required',
		},
		{
			title:      'Você é síndico?',
			name:       'eh-sindico',
			type:       'select',
			selectValues: [
				{
					title: 'Selecione',
					value: ''
				},
				{
					title: 'Sim',
					value: 'Sim'
				},
				{
					title: 'Não',
					value: 'Não'
				}
			]
		},          
		{
			title:      'Nome do condomínio *',
			name:       'condominio-nome',
			required:   'required'
		},
		{
			title:      'Endereço *',
			name:       'condominio-endereco',
			required:   'required'
		},   
		   
	];      
	
	const message = `
Seu nome: {nome}
Telefone: {telefone}
Email: {email}
Você é síndico?: {eh-sindico}
Nome do condomínio: {condominio-nome}
Endereço: {condominio-endereco}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}    

</script>

<PageHeader title={titlePage} buttons=""></PageHeader>
<div class="container clearfix text-justify">
	<p class="text-center">
		Estamos prontos para assessorá-lo a encontrar as melhores soluções para o seu condomínio.
	</p>
	<p class="text-center">
		Venha conhecer nossa empresa ou solicite-nos uma proposta, que brevemente entraremos em contato com você.
	</p>
	<p class="text-center">
		Se preferir, fale conosco pelo Whatsapp <a class="btn btn-primary bg-whatsapp" href="{$linkWhatsappCondominio}" target="_blank"><i class="fab fa-whatsapp"></i> {$textWhatsappCondominio}</a> ou utilize o formulário abaixo.
	</p>
	<div class="offset-md-3 col-md-6 pl-0 pr-0">
		<hr class="line-separator">
		<Forms fields={fields} destiny={$mailCondominios} subjectTitle="{titlePage}" {message} htmlbody={false} />
	</div>
</div>